import { useEffect, useRef } from 'react'
import { useStore } from '../../../models'
import { toastNotificationStore } from '../../../components/ANewDesign/ToastNotification/ToastNotification'

/**
 * MobX-State-Tree variant of `useListenGameToastNotificationsConvex` for
 * non-Convex game screens. Same ownership rule applies: this hook only
 * manages teacher-viewing toasts and must not clobber toasts set by other
 * features (e.g. table-move toasts persisting across navigation).
 */
export const useListenGameToastNotifications = () => {
  const {
    game: { isMyCardsVisibleByTeacher, isCardsVisibleByTeacher, isMyPlayerTeacher, isMyPlayerObserver }
  } = useStore()
  // Tracks whether the most recent teacher toast we posted is still showing.
  const ownedTeacherToastRef = useRef(false)

  useEffect(() => {
    if (isMyCardsVisibleByTeacher) {
      ownedTeacherToastRef.current = true
      // `duration: 0` keeps the toast visible until the condition clears
      // (the teacher closes their view). The queue still respects it.
      toastNotificationStore.getState().show({ text: 'Teacher is viewing your cards', duration: 0 })
    } else if (ownedTeacherToastRef.current) {
      ownedTeacherToastRef.current = false
      toastNotificationStore.getState().dismiss()
    }
  }, [isMyCardsVisibleByTeacher])

  useEffect(() => {
    const onShowAllPlayersCardsForTeacher = !(isMyPlayerTeacher && isMyPlayerObserver) && isCardsVisibleByTeacher
    if (onShowAllPlayersCardsForTeacher) {
      ownedTeacherToastRef.current = true
      toastNotificationStore.getState().show({ text: 'Teacher is viewing your cards', duration: 0 })
    } else if (ownedTeacherToastRef.current) {
      ownedTeacherToastRef.current = false
      toastNotificationStore.getState().dismiss()
    }
  }, [isCardsVisibleByTeacher, isMyPlayerObserver, isMyPlayerTeacher])
}
